<template>
  <div class="asset-page">
    <van-nav-bar
      title="资产"
      left-arrow
      @click-left="goHome"
    />

    <div class="top-card">
      <div class="top-title">数字人民币管理</div>
      <div class="top-desc">绑定数字人民币用于大额拨付业务</div>
    </div>

    <div class="content">
      <div class="section-title">
        <span class="title-line"></span>
        <span>数字人民币</span>
      </div>

      <div class="bank-list">
        <div
          v-for="item in bankList"
          :key="item.type"
          class="bank-item"
          @click="goBind(item)"
        >
          <div class="bank-left">
            <div class="bank-icon">
  <img :src="item.img" />
</div>
            <div class="bank-info">
              <div class="bank-name">{{ item.name }}</div>
              <div class="bank-desc">
                {{ item.type === "other" ? "其他机构" : "数字人民币" }}
              </div>
            </div>
          </div>

          <div class="bank-right">
           <span
  :class="[
    'status',
    getStatusClass(item)
  ]"
>
  {{ getStatusText(item) }}
</span>
            <span class="arrow">›</span>
          </div>
        </div>
      </div>

      <div class="notice">
        <div class="notice-title">
          <span class="notice-icon">!</span>
          <span>温馨提示</span>
        </div>
        <div class="notice-text">
          绑定数字人民币前需开通大额拨付业务，请确保数字人民币信息真实有效。
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import request from "@utils/request";

export default {
  name:"Asset",
  data(){
    return {
      loading:true,
      largePayStatus:0,
      bankList:[
        {
          type:"icbc",
          name:"工商银行",
          img:require("@/assets/images/gsyh.png"),
          bound:false,
          status:-1
        },
        {
          type:"abc",
          name:"农业银行",
          img:require("@/assets/images/nyyh.png"),
          bound:false,
          status:-1
        },
        {
          type:"boc",
          name:"中国银行",
          img:require("@/assets/images/zgyh.png"),
          bound:false,
          status:-1
        },
        {
          type:"ccb",
          name:"建设银行",
          img:require("@/assets/images/jsyh.png"),
          bound:false,
          status:-1
        },
        {
          type:"other",
          name:"其他机构",
          img:require("@/assets/images/qtyh.png"),
          bound:false,
          status:-1
        }
      ]
    };
  },
  mounted(){
    this.getLargePayStatus();
  },
  methods:{
    async getLargePayStatus(){
      try{
        const res=await request.get("/api/v1/user/largePayStatus");

        const result=res&&res.code!==undefined
          ?res
          :(res&&res.data?res.data:null);

        if(result&&result.code===200){
          this.largePayStatus=Number(
            result.data&&result.data.large_pay_status
          )||0;

          const bankList=result.data&&result.data.bankList
            ?result.data.bankList
            :[];

          this.bankList=this.bankList.map(item=>{
            const bank=bankList.find(
              v=>v.bank_type===item.type
            );

            if(!bank){
              return {
                ...item,
                bound:false,
                status:-1
              };
            }

            return {
              ...item,
              bound:Number(bank.status)===1,
              status:Number(bank.status)
            };
          });
        }
      }catch(e){
        console.log("获取大额拨付及数字人民币状态失败",e);
      }finally{
        this.loading=false;
      }
    },

    goHome(){
      this.$router.push({
        path:"/"
      });
    },

    getStatusText(item){
      if(item.status===1){
        return "已绑定";
      }

      if(item.status===0){
        return "审核中";
      }

      if(item.status===2){
        return "审核拒绝";
      }

      return "未绑定";
    },

    getStatusClass(item){
      if(item.status===1){
        return "status-success";
      }

      if(item.status===0){
        return "status-warning";
      }

      if(item.status===2){
        return "status-danger";
      }

      return "status-default";
    },

    goBind(item){
      if(this.largePayStatus!==1){
        this.$dialog.error("绑定数字人民币需开通大额拨付业务");
        return;
      }

      // 当前点击的已经绑定
      if(item.status===1){
        this.$dialog.error("已绑定成功，请勿重复绑定！");
        return;
      }

      // 当前点击的正在审核
      if(item.status===0){
        this.$dialog.error("该数字人民币正在审核中，请耐心等待");
        return;
      }

      // 只要任意一个数字人民币已经绑定成功，就不能再绑定其他银行
      const hasBound=this.bankList.some(
        v=>v.status===1
      );

      if(hasBound){
        this.$dialog.error("已绑定成功，请勿重复绑定！");
        return;
      }

      // 未绑定或者审核拒绝，可以提交
      this.$router.push({
        path:"/assetBankBind",
        query:{
          type:item.type,
          name:item.name
        }
      });
    }
  }
};
</script>

<style scoped>
.asset-page{
  min-height:100vh;
  background:#f7f8fa;
  box-sizing:border-box;
  padding-bottom:30px;
}

.top-card{
  margin:-1px 12px 0;
  padding:22px 20px 24px;
  border-radius:0 0 14px 14px;
  background:linear-gradient(135deg,#ff3c24,#ff1900);
  color:#fff;
  box-shadow:0 5px 15px rgba(255,25,0,.18);
}

.top-title{
  font-size:21px;
  font-weight:700;
  margin-bottom:8px;
}

.top-desc{
  font-size:12px;
  opacity:.9;
}

.content{
  padding:20px 12px 0;
}

.section-title{
  display:flex;
  align-items:center;
  margin:0 4px 12px;
  font-size:16px;
  color:#222;
  font-weight:700;
}

.title-line{
  width:4px;
  height:17px;
  margin-right:8px;
  border-radius:3px;
  background:#ff1900;
}

.bank-list{
  overflow:hidden;
  background:#fff;
  border-radius:13px;
  box-shadow:0 3px 15px rgba(0,0,0,.04);
}

.bank-item{
  height:72px;
  padding:0 16px;
  display:flex;
  align-items:center;
  justify-content:space-between;
  border-bottom:1px solid #f1f1f1;
  box-sizing:border-box;
}

.bank-item:last-child{
  border-bottom:0;
}

.bank-left{
  display:flex;
  align-items:center;
  min-width:0;
}

.bank-icon{
  width:43px;
  height:43px;
  margin-right:12px;
  display:flex;
  align-items:center;
  justify-content:center;
  border-radius:50%;
  background:#fff1eb;
  color:#ff4b0b;
  font-size:17px;
  font-weight:700;
}

.bank-info{
  min-width:0;
}

.bank-name{
  color:#222;
  font-size:14px;
  font-weight:600;
  line-height:20px;
}

.bank-desc{
  margin-top:2px;
  color:#aaa;
  font-size:11px;
  line-height:17px;
}

.bank-right{
  display:flex;
  align-items:center;
  flex-shrink:0;
}

.status{
  font-size:12px;
}

.status-success{
  color:#22a06b;
}

.status-default{
  color:#999;
}

.arrow{
  margin-left:7px;
  color:#c8c8c8;
  font-size:22px;
  line-height:1;
}

.notice{
  margin-top:14px;
  padding:15px;
  background:#fff;
  border-radius:12px;
}

.notice-title{
  display:flex;
  align-items:center;
  color:#ff5a16;
  font-size:13px;
  font-weight:600;
  margin-bottom:7px;
}

.notice-icon{
  width:17px;
  height:17px;
  margin-right:7px;
  display:flex;
  align-items:center;
  justify-content:center;
  border-radius:50%;
  background:#fff0e9;
  color:#ff5a16;
  font-size:11px;
}

.notice-text{
  color:#888;
  font-size:11px;
  line-height:1.7;
}
.status-warning{
  color:#ff9800;
}

.status-danger{
  color:#f44336;
}
.bank-icon{
    width:45px;
    height:45px;
    display:flex;
    align-items:center;
    justify-content:center;
    border-radius:50%;
    overflow:hidden;
}

.bank-icon img{
    width:100%;
    height:100%;
    object-fit:contain;
}
</style>
